import styled, { css } from 'styled-components';
import { prop } from 'ramda';
import { themeColor, whenThemePropEqualsTrue } from '../../../theme/getters';
import { paragraph, primaryText, smallParagraph } from '../../../theme/typography';

const whenHasValue = whenThemePropEqualsTrue('hasValue');
const whenHasError = whenThemePropEqualsTrue('hasError');
const whenIsLight = whenThemePropEqualsTrue('isLight');
const whenIsDisabled = whenThemePropEqualsTrue('disabled');

const getStylesWithValue = whenHasValue(
  () => css`
    border-color: ${themeColor('white')};
  `
);

const getDisabledStyles = whenIsDisabled(
  () => css`
    opacity: 0.3;
  `
);

const getStylesWithError = whenHasError(
  () => css`
    border-color: ${themeColor('error')};
  `
);

const getLightStyles = whenIsLight(
  () => css`
    border-color: ${themeColor('border')};
    color: ${themeColor('primary')};
    &:focus {
      border-color: ${themeColor('border')};
    }
  `
);

export const Field = styled.input`
  ${paragraph};
  width: 100%;
  border: 1px solid ${themeColor('border')};
  border-radius: 0;
  appearance: none;
  background: transparent;
  padding: 16px;
  color: ${themeColor('white')};

  &::placeholder {
    color: ${themeColor('gray')};
  }

  &:focus {
    outline: 0;
    border-color: ${themeColor('white')};
  }
  ${getStylesWithValue};
  ${getLightStyles};
  ${getStylesWithError};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${prop('extraStyles')};
  ${getDisabledStyles};
`;

export const ErrorText = styled.span`
  ${smallParagraph};
  display: block;
  width: 100%;
  padding: 0px;
  margin-top: 8px;
  text-align: left;
  color: ${themeColor('error')};
`;

export const Label = styled.span`
  ${primaryText};
  display: block;
  width: 100%;
  margin-bottom: 8px;
  text-align: left;
  font-size: 16px;
  line-height: 21px;
`;
